<template>
  <Modal
    :modal="groupStructureModalRef"
    :steps="[
      {
        id: 'group-structure',
        component: GroupStructureModalContent,
      },
    ]"
  />
</template>

<script lang="ts" setup>
import GroupStructureModalContent from '@/features/admin/groups/components/group-structure-modal/group-structure-modal-content/group-structure-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetAdminGroupStructureModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const groupStructureModalRef = selectGetAdminGroupStructureModal(modalsStore)
</script>
